/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    MoyaComponents.register('rnb.assistant-report', function (el) {
        var config = {
            el: el,
            itemDates: el.querySelectorAll('input.item-date'),
            periodSelect: el.querySelector('#period'),
            expenditureInputs: el.querySelectorAll('input.expenditure'),
            drivingDistanceInputs: el.querySelectorAll('input.driving-distance'),
            hourInputs: el.querySelectorAll('select.hours'),
            minuteInputs: el.querySelectorAll('select.minutes'),
            itemFieldsets: el.querySelectorAll('fieldset[id*="fieldset-item"]'),
        };
        AssistantReport.create(config);
    });
    var AssistantReport = /** @class */ (function () {
        function AssistantReport(config) {
            this.totalExpenditure = 0;
            this.totalDrivingDistance = 0;
            this.totalHours = 0;
            this.totalMinutes = 0;
            this.el = config.el;
            this.itemDates = config.itemDates;
            this.periodSelect = config.periodSelect;
            this.expenditureInputs = config.expenditureInputs;
            this.drivingDistanceInputs = config.drivingDistanceInputs;
            this.hourInputs = config.hourInputs;
            this.minuteInputs = config.minuteInputs;
            this.itemFieldsets = config.itemFieldsets;
        }
        AssistantReport.create = function (config) {
            MoyaEventHandler.on('rnb.datepickers-initialized', function () {
                var instance = new AssistantReport(config);
                instance.run();
            });
        };
        AssistantReport.prototype.run = function () {
            this.delegateEvents();
            this.calculateAndUpdateTotals();
            this.handlePeriodChange();
            this.itemFieldsetsHideAll();
            this.itemFieldsetsShowDirtyOrFirst();
            this.fixInputNumbers();
        };
        AssistantReport.prototype.delegateEvents = function () {
            var _this = this;
            util.delegate(this.el, 'change', '#period', function (e) { return _this.handlePeriodChange(); });
            util.delegate(this.el, 'click', '#item-toggle', function (e) {
                e.preventDefault();
                _this.itemFieldsetsShowNext();
            });
            util.delegate(this.el, 'keyup', 'input.expenditure', function (e) { return _this.calculateAndUpdateTotals(); });
            util.delegate(this.el, 'change', 'input.expenditure', function (e) { return _this.calculateAndUpdateTotals(); });
            util.delegate(this.el, 'keyup', 'input.driving-distance', function (e) { return _this.calculateAndUpdateTotals(); });
            util.delegate(this.el, 'change', 'input.driving-distance', function (e) { return _this.calculateAndUpdateTotals(); });
            util.delegate(this.el, 'change', 'select.hours', function (e) { return _this.calculateAndUpdateTotals(); });
            util.delegate(this.el, 'change', 'select.minutes', function (e) { return _this.calculateAndUpdateTotals(); });
        };
        AssistantReport.prototype.handlePeriodChange = function () {
            var _a = this.periodSelect.value
                .split('-')
                .map(function (val) {
                return parseInt(val);
            }), minTimestamp = _a[0], maxTimestamp = _a[1];
            var jsMinDate = new Date(minTimestamp * 1000);
            var jsMaxDate = new Date(maxTimestamp * 1000);
            var formattedMinDate = jsMinDate.getDate() + "." + (jsMinDate.getMonth() + 1) + "." + jsMinDate.getFullYear();
            var formattedMaxDate = jsMaxDate.getDate() + "." + (jsMaxDate.getMonth() + 1) + "." + jsMaxDate.getFullYear();
            this.itemDates.forEach(function (el) {
                var key = 'rnb.datepicker-' + el.id;
                var instance = MoyaContainer.get(key);
                if (!instance) {
                    return;
                }
                instance.set('minDate', formattedMinDate);
                instance.set('maxDate', formattedMaxDate);
                instance.jumpToDate(formattedMinDate);
                var selectedDate = instance.selectedDates.length ? instance.selectedDates[0] : null;
                if (!selectedDate) {
                    return;
                }
                var selectedTimestamp = selectedDate.getTime() / 1000;
                if (selectedTimestamp < minTimestamp || selectedTimestamp > maxTimestamp) {
                    instance.clear(true);
                }
            });
        };
        AssistantReport.prototype.calculateAndUpdateTotals = function () {
            this.calculateTotals();
            this.updateTotals();
        };
        AssistantReport.prototype.calculateTotals = function () {
            this.totalExpenditure = Array.from(this.expenditureInputs).reduce(function (a, b) {
                var val = parseInt(b.value);
                return a + ((isNaN(val) || val < 0) ? 0 : val);
            }, 0);
            this.totalDrivingDistance = Array.from(this.drivingDistanceInputs).reduce(function (a, b) {
                var val = parseInt(b.value);
                return a + ((isNaN(val) || val < 0) ? 0 : val);
            }, 0);
            var totalMinutes = Array.from(this.minuteInputs).reduce(function (a, b) {
                var val = parseInt(b.value);
                return a + ((isNaN(val) || val < 0) ? 0 : val);
            }, 0);
            var totalHoursAsMinutes = Array.from(this.hourInputs).reduce(function (a, b) {
                var val = parseInt(b.value);
                return a + ((isNaN(val) || val < 0) ? 0 : val);
            }, 0) * 60;
            totalMinutes += totalHoursAsMinutes;
            this.totalHours = Math.floor(totalMinutes / 60);
            this.totalMinutes = totalMinutes % 60;
        };
        AssistantReport.prototype.updateTotals = function () {
            var totalHoursEl = document.querySelector('.total-hours');
            var totalMinutesEl = document.querySelector('.total-minutes');
            var totalDrivingDistanceEl = document.querySelector('.total-driving-distance');
            var totalExpenditureEl = document.querySelector('.total-expenditure');
            totalHoursEl.innerHTML = this.totalHours + ' ' + totalHoursEl.dataset.unit;
            totalMinutesEl.innerHTML = this.totalMinutes + ' ' + totalMinutesEl.dataset.unit;
            totalDrivingDistanceEl.innerHTML = this.totalDrivingDistance + ' ' + totalDrivingDistanceEl.dataset.unit;
            totalExpenditureEl.innerHTML = this.totalExpenditure + ' ' + totalExpenditureEl.dataset.unit;
        };
        AssistantReport.prototype.itemFieldsetsHideAll = function () {
            Array.from(this.itemFieldsets)
                .forEach(function (fieldset) {
                hideElement(fieldset);
            });
        };
        AssistantReport.prototype.itemFieldsetsShowNext = function () {
            var nextWasShown = false;
            Array.from(this.itemFieldsets)
                .forEach(function (item) {
                if (!nextWasShown && elementIsHidden(item)) {
                    showElement(item);
                    nextWasShown = true;
                }
            });
        };
        AssistantReport.prototype.itemFieldsetsShowDirtyOrFirst = function () {
            var dirtyFieldsets = [];
            Array.from(this.itemFieldsets)
                .forEach(function (item) {
                var elements = Array.from(item.querySelectorAll('input, select, textarea'));
                elements.forEach(function (el) {
                    var hasErrors = el.closest('.elm').querySelectorAll('.errors').length > 0;
                    var intVal = parseInt(el.value);
                    var hasIntVal = intVal > 0;
                    var hasStrVal = isNaN(intVal) && el.value.trim() !== '';
                    if ((hasIntVal || hasStrVal) || hasErrors) {
                        dirtyFieldsets.push(item);
                    }
                });
            });
            if (!dirtyFieldsets.length) {
                showElement(this.itemFieldsets[0]);
            }
            else {
                dirtyFieldsets.forEach(function (dirtyFieldset) {
                    showElement(dirtyFieldset);
                });
            }
        };
        AssistantReport.prototype.fixInputNumbers = function () {
            Array.from(this.el.querySelectorAll('input[type=number]'))
                .forEach(function (inputNumber) {
                var val = parseInt(inputNumber.value);
                if (val <= 0) {
                    inputNumber.value = '';
                }
            });
        };
        return AssistantReport;
    }());
    function elementIsHidden(el) {
        return el.classList.contains('hide');
    }
    function hideElement(el) {
        el.classList.add('hide');
    }
    function showElement(el) {
        el.classList.remove('hide');
    }

}());
typeof tsBuild === 'function' && tsBuild();})();
